<template>
    <structure>
        <section class="reports">
            <section class="title">
                <h1>Seja bem vindo</h1>
                <p>Esses são o resumo das informações de utilização do sistema.</p>
            </section>
            <section class="dash">
                <div class="row">
                    <div class="item">
                        <div class="box">
                            <div class="icon">80/15/10</div>
                            <div class="text">Chamados</div>
                        </div>
                    </div>
                    <div class="item">
                        <div class="box">
                            <div class="icon">
                                10
                            </div>
                            <div class="text">Usuários</div>
                        </div>
                    </div>
                    <div class="item">
                        <div class="box">
                            <div class="icon">
                                10
                            </div>
                            <div class="text">Vagas de Emprego</div>
                        </div>
                    </div>
                    <div class="item">
                        <div class="box">
                            <div class="icon">
                                10
                            </div>
                            <div class="text">Currículos</div>
                        </div>
                    </div>
                </div>
                <div class="row">
                    
                    <div class="item">
                        <div class="box">
                            <div class="icon">
                                <i class="fal fa-file-alt"></i>
                            </div>
                            <div class="text">Configurações</div>
                        </div>
                    </div>
                    <div class="item">
                        <div class="box">
                            <div class="icon">
                                <i class="fal fa-user-tie"></i>
                            </div>
                            <div class="text">Vagas de empregos</div>
                        </div>
                    </div>
                    
                </div>
            </section>
            <section class="control">
                <button type="button">
                    <i class="fal fa-plus"></i>
                </button>
            </section>
        </section>
    </structure>
</template>

<script>
    import structure from '@/templates/private'
    export default {
        name: 'login',
        components: { structure },
        methods: {
            goTo(page){
                this.$router.push({ path: page })
            },
        }
    }
</script>


<style lang="stylus" scoped>
    @import 'styles.styl';
</style>
